import React from 'react'

import { PromotionStatusTag } from '@components/common/PromotionStatusTag'

import type { Promotion } from '../../../../Promotions.types'
import { PromotionCodeTableCell } from '../PromotionCodeTableCell/PromotionCodeTableCell'
import { PromotionUsageTableCell } from '../PromotionUsageTableCell/PromotionUsageTableCell'
import * as S from './PromotionCodeListItem.styled'

type PromotionCodeListItemProps = {
  promotion: Promotion
}

export const PromotionCodeListItem = ({ promotion }: PromotionCodeListItemProps) => {
  return (
    <S.Container>
      <PromotionCodeTableCell promotion={promotion} />
      <PromotionStatusTag promotion={promotion} />
      <S.UsageWrapper>
        <PromotionUsageTableCell promotion={promotion} /> used
      </S.UsageWrapper>
    </S.Container>
  )
}
